module.exports = __webpack_public_path__ + "static/media/slider_5_master_user_en.9de697e9.svg";